export const ADD_ORG_DIALOG = {
    ADD_ORG_TITLE: { key: 'ADD_ORG_TITLE', value: 'Add New Organization' },
    ADDING_ORG_TITLE: { key: 'ADDING_ORG_TITLE', value: 'Adding Organization' },
    MODAL_TITLE: { key: 'MODAL_TITLE', value: 'Add New Organization' },
    ADD_ORG_SUBTITLE: { key: 'ADD_ORG_SUBTITLE', value: 'Fill in the details to create a new organization' },
    ORG_NAME_LABEL: { key: 'ORG_NAME_LABEL', value: 'Organization Name' },
    ORG_TYPE_LABEL: { key: 'ORG_TYPE_LABEL', value: 'Organization Type' },
    PHONE_NUMBER_LABEL: { key: 'PHONE_NUMBER_LABEL', value: 'Phone Number' },
    FIRSTNAME_LABEL: { key: 'FIRSTNAME_LABEL', value: 'Contact First Name' },
    LASTNAME_LABEL: { key: 'LASTNAME_LABEL', value: 'Contact Last Name' },
    EMAIL_LABEL: { key: 'EMAIL_LABEL', value: 'Contact Email' },
    ADDRESS_LINE1_LABEL: { key: 'ADDRESS_LINE1_LABEL', value: 'Address Line 1' },
    ADDRESS_LINE2_LABEL: { key: 'ADDRESS_LINE2_LABEL', value: 'Address Line 2' },
    CITY_LABEL: { key: 'CITY_LABEL', value: 'City' },
    ZIPCODE_LABEL: { key: 'ZIPCODE_LABEL', value: 'ZIP Code' },
    STATE_LABEL: { key: 'STATE_LABEL', value: 'State' },
    COUNTRY_LABEL: { key: 'COUNTRY_LABEL', value: 'Country' },
    CANCEL_LABEL: { key: 'CANCEL_LABEL', value: 'Cancel' }
}

export const ORGANIZATION_PAGE = {
    SEARCH_ORG_INPUT_TEXT: { key: 'SEARCH_ORG_INPUT_TEXT', value: 'Search by Organization Name...' },
    PAGE_TITLE: { key: 'PAGE_TITLE', value: 'Organization Management' },
    PAGE_DESCRIPTION: { key: 'PAGE_DESCRIPTION', value: 'Centralized hub to manage, monitor, and analyze all organizations across your platform' },
    ADD_ORG_BTN_LABEL: { key: 'ADD_ORG_BTN_LABEL', value: 'Add Organization' },
    ADD_FIRST_ORG: { key: 'ADD_FIRST_ORG', value: 'Add Your First Organization' },
    NO_ORGS_TITLE: { key: 'NO_ORGS_TITLE', value: 'No Organizations Yet' },
    NO_ORGS_DESCRIPTION: { key: 'NO_ORGS_DESCRIPTION', value: 'Click the button below to create a new organization and begin managing your platform.' },
    NO_ORGS_MATCHES_TITLE: { key: 'NO_ORGS_MATCHES_TITLE', value: 'No Organizations Found' },
    NO_ORGS_MATCHING: { key: 'NO_ORGS_MATCHING', value: 'We couldn\'t find any organizations matching' },
    TRY_CLEARING_SEARCH: { key: 'TRY_CLEARING_SEARCH', value: 'Try adjusting your search terms or clearing the filters.' },
    CLEAR_SEARCH: { key: 'CLEAR_SEARCH', value: 'Clear Search' },
    OPEN_BTN_LABEL: {key: 'OPEN_BTN_LABEL', value: 'Open'},
    ACTIVATE_BTN_LABEL: {key: 'ACTIVATE_BTN_LABEL', value: 'Activate'},
    INACTIVATE_BTN_LABEL: {key: 'INACTIVATE_BTN_LABEL', value: 'Inactivate'},
    CONFIRM_BUTTON: {key: 'CONFIRM_BUTTON', value: 'Confirm'},
    CONFIRM_MODAL_DELETE_DESCRIPTION: {key: 'CONFIRM_MODAL_DESCRIPTION', value: 'Are you sure you want to delete this organization?'},
    CONFIRM_MODAL_INACTIVATE_DESCRIPTION: {key: 'CONFIRM_MODAL_INACTIVATE_DESCRIPTION', value: 'Are you sure you want to inactivate this organization?'},
    ORGANIZATION_CREATED: { key: 'ORGANIZATION_CREATED_MESSAGE', value: 'Organization created successfully'},
    CREATE_ORG_FAILED: { key:'CREATE_ORG_FAILED', value: 'Failed to create organization' },
    SHOWING_LABEL: { key: 'SHOWING_LABEL', value: 'Showing'},
    OF_LABEL: { key: 'OF_LABEL', value: 'of'},
    ORGANIZATIONS_LABEL: { key: 'ORGANIZATIONS_LABEL', value: 'organizations'},
}

export const FEATURES = {
    SELECT_ALL_FEATURES: { key: 'SELECT_ALL_FEATURES', value: 'Select All Features'},
    SAVE_FEATURES: { key: 'SAVE_FEATURES', value: 'Save Features' },
    MANAGE_FEATURES: { key: 'MANAGE_FEATURES', value: 'Manage Features' }
}